/*
 * Copyright (c) 2024 - 2026 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * @class - Represents a callback used to initialize and start device and behavioral data collection.
 */
export class PingOneProtectInitializeCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Get callback's initialization config settings
     */
    getConfig() {
        const signalsInitializationOptions = this.getOutputByName('signalsInitializationOptions', undefined);
        if (signalsInitializationOptions !== null &&
            typeof signalsInitializationOptions === 'object' &&
            !Array.isArray(signalsInitializationOptions)) {
            return signalsInitializationOptions;
        }
        const config = {
            envId: this.getOutputByName('envId', ''),
            consoleLogEnabled: this.getOutputByName('consoleLogEnabled', false),
            deviceAttributesToIgnore: this.getOutputByName('deviceAttributesToIgnore', []),
            customHost: this.getOutputByName('customHost', ''),
            lazyMetadata: this.getOutputByName('lazyMetadata', false),
            behavioralDataCollection: this.getOutputByName('behavioralDataCollection', true),
            deviceKeyRsyncIntervals: this.getOutputByName('deviceKeyRsyncIntervals', 14),
            enableTrust: this.getOutputByName('enableTrust', false),
            disableTags: this.getOutputByName('disableTags', false),
            disableHub: this.getOutputByName('disableHub', false),
        };
        return config;
    }
    setClientError(errorMessage) {
        this.setInputValue(errorMessage, /clientError/);
    }
}
